import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "9", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "15", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "9", x2: "9", y1: "9", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "15", y1: "9", y2: "21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Sheet";
const Sheet = memo(themed(Icon));
export {
  Sheet
};
//# sourceMappingURL=sheet.js.map
